import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { RetrievalService } from '../retrieval/retrieval.service';
import { WebUploadService } from './web-upload.service';
import { BusinessArea, DocumentType } from '../../models/model';
import { MatSelectChange } from '@angular/material/select';
import { WebUploadIndexingFields } from '../../models/index-fields';
import { FormArray, FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { UserSystemPreference } from '../../models/userSystemPreference';
import { UploadOptionsResponse, WebUpload } from '../../models/webUpload';
import { GlobalService } from '../../services/global.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { CommonService } from '../../services/common.service';
import { DateAdapter } from '@angular/material/core';
import { DynamicDateAdapter } from '../../common/dynamic-date-adapter';
import moment from 'moment';
import { DateService } from '../../services/date.service';
@Component({
  selector: 'app-web-upload',
  templateUrl: './web-upload.component.html',
  styleUrl: './web-upload.component.scss',
})
export class WebUploadComponent {
  @ViewChild('indexingFieldsPanel') indexingFieldsPanel!: MatExpansionPanel;
  @ViewChild('mainForm', { static: true }) mainForm!: NgForm;
  @ViewChild('accordion') accordion!: any;
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;

  ngAfterViewInit(): void {
    // Wait for view to fully initialize and then open the first panel
    setTimeout(() => {
      const firstPanel = this.panels.first;
      if (firstPanel) {
        firstPanel.open();
      }
    });
  }

  form!: FormGroup;
  selectedDocTypeName!: string;
  documentType: number = 0;
  isSelectResultsLoading: any;
  documentQueue: any[] = [];
  selectedstartQueueId!: number;
  businessAreaList: BusinessArea[] = [];
  documentTypes: DocumentType[] = [];
  selectedBusinessArea!: number;
  selectedDocumentType!: number;
  webUploadIndexFields: WebUploadIndexingFields | undefined;
  webUploadDto!: WebUpload;
  userSystemPreferences: UserSystemPreference[] = [];
  user: any;
  uploadOptionsQueueOnSelect: any;
  sendToNotification: boolean = true;
  isBusinessAreaAvailable: boolean = false;
  isDocumentTypeOptions: boolean = false;
  isBusinessAreaLoaded: boolean = true;
  isFormSubmitted: boolean = false;
  isAddtoExistingBatchEnabled: boolean = false;
  enabledBatch: string = 'add';
  sendToWorkflow: boolean = true;
  isSendToWorkFlowEnabled: boolean = false;
  isSendToNotificationEnabled: boolean = false;
  selectResults: any[] = [];
  isFileTypeExist: boolean = true;
  selectedFiles: File[] = [];
  files: File[] = [];
  isFileCountExceeded: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  allowedFileTypes: string[] = [];
  maxFileSizeMB = 0;
  maxFilesLimit = 0;
  uploadLimitFailure: boolean = false;
  invalidFileTypes: string[] = [];
  oversizedFiles: string[] = [];
  duplicateFiles: string[] = []; 
  isIndexFieldsLoading: boolean = false;
  isBALoading: boolean = true;
  isDocTypeLoading: boolean = true;
  isSubmitting: boolean = false;

  get isLoading(): boolean {
    return this.isIndexFieldsLoading || this.isSubmitting;
  } 
  constructor(
    private readonly retrievalService: RetrievalService,
    private readonly webUploadService: WebUploadService,
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService,
    private readonly dateAdapter: DateAdapter<any>,
    private readonly fb: FormBuilder,
    private readonly dateService: DateService,
  ) { }

  async ngOnInit() {
    this.commonService.clearMessage();
    this.form = this.fb.group({
      indexingFields: this.fb.array([]),
    });
    await this.callRegisterPrincipal(Number(this.globalVariable.getSelectedSystemId));
    this.getUploadFileOptions();
    this.assignBusinessArea();
    this.getUserSystemPerferences();
  }

  callRegisterPrincipal(systemId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.commonService.callRegisterPrincipal(systemId).subscribe({
        next: (response) => {
          resolve();
        },
        error: (error) => {
          this.commonService.openErrorDialog(error.error.message);
          this.commonService.showMessage('User registration failed', 'error');
          reject(error);
        }
      });
    });
  }

  get indexingFields(): FormArray {
    return this.form.get('indexingFields') as FormArray;
  }

  get hasStartingQueueOptions(): boolean {
    return Array.isArray(this.webUploadIndexFields?.startingQueueOptions) && this.webUploadIndexFields.startingQueueOptions.length > 0;
  }

  getDatePlaceholder(index: number): string {
    const format = this.indexingFields.at(index).value.fieldDateFormat?.defaultFormat;
    return format?.split(' ')[0] || 'DD/MM/YYYY';
  }

  getUploadFileOptions(): void {
    this.commonService.getUploadFileOptions().subscribe({
      next: (response: UploadOptionsResponse) => {
        if (response) {
          const sizeMatch = response.sizeLimit.match(/(\d+)/);
          this.maxFileSizeMB = sizeMatch ? parseInt(sizeMatch[1], 10) : 100;
          this.maxFilesLimit = response.filesLimit;
          this.allowedFileTypes = response.fileTypes
            .split(',')
            .map((ext: string) => ext.trim().toUpperCase());
        }
      },
      error: () => {
        console.error('Failed to fetch upload options.');
      },
    });
  }

  getReadableFileTypes(): string {
    return this.allowedFileTypes
      .map((ext) => ext.replace('.', '').toUpperCase())
      .join('/');
  }

  assignBusinessArea(): void {
    this.isBALoading = true;
    this.retrievalService.getBusinessAreaList(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId)
    .subscribe({
      next: (response) => {
        this.isBALoading = false;
        this.businessAreaList = response;
      },
      error: (error) => {
        this.isBALoading = true;
        this.commonService.showMessage('Failed to fetch Bussiness Areas.','error');
      },
    });
  }

  getDocumentTypesBasedOnBusinessArea(event: MatSelectChange): void {
    this.form = this.fb.group({
      indexingFields: this.fb.array([]),
    });
    this.resetImage();
    if (this.selectedBusinessArea) {
      this.isDocTypeLoading = true;
      this.webUploadService.getDocumentTypeList(this.selectedBusinessArea, this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId)
      .subscribe({
        next: (response) => {
          this.documentTypes = response; 
          this.isDocTypeLoading = false;
          if (this.documentTypes.length === 1) {
            this.selectedDocumentType = this.documentTypes[0].id;
            this.selectedDocTypeName = this.documentTypes[0].name;
            const mockEvent: MatSelectChange = {
              source: {
                triggerValue: this.selectedDocTypeName,
              },
            } as MatSelectChange;
            this.getIndexFieldsBasedOnDocumentType(mockEvent);
          }
        },
        error: (error) => {
          this.isDocTypeLoading = true;
          this.commonService.showMessage('Failed to fetch Document Types.', 'error');
        },
      });
    }
  }

  getIndexFieldsBasedOnDocumentType(event: MatSelectChange): void {
    this.selectedDocTypeName = event.source.triggerValue;
    this.isIndexFieldsLoading = true;
    if (this.selectedDocumentType) {
      // Clear previous indexing fields before adding new indexing fields
      (this.form.get('indexingFields') as FormArray).clear();
      this.webUploadService.getIndexFieldsBasedOnDoctype(this.selectedDocumentType, this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId)
        .subscribe({
          next: (response) => {
            this.isIndexFieldsLoading = false;
            this.webUploadIndexFields = response;
            if(this.webUploadIndexFields.startingQueueOptions.length == 0) {
              this.sendToWorkflow = false;
            }
            const fieldData = this.webUploadIndexFields.indexingFields;
            fieldData.forEach((field) => {
              const group = this.fb.group({
                columnName: [field.columnName || null],
                docTypeId: [field.docTypeId || null],
                docTypeName: [field.docTypeName || null],
                controlType: [field.controlType || null],
                fieldLength: [field.fieldLength || null],
                fieldOrder: [field.fieldOrder || null],
                isMandatory: [field.isMandatory || false],
                allowMultiples: [field.allowMultiples || false],
                useLastIndexingValue: [field.useLastIndexingValue || false],
                showInInbox: [field.showInInbox || false],
                preIndexValue: [field.preIndexValue || null],
                mask: [field.mask || null],
                toolTip: [field.toolTip || null],
                dataSource: [field.dataSource || null],
                fieldDataType: [field.fieldDataType || null],
                controlName: [field.controlName || null],
                valueAsString: [field.valueAsString || null],
                comboValues: [field.comboValues || []],
                fieldDateFormat: this.fb.group({
                  cultureName: [field.fieldDateFormat?.cultureName || null],
                  language: [field.fieldDateFormat?.language || null],
                  defaultFormat: [
                    field.fieldDateFormat?.defaultFormat ||
                    'dd/MM/yyyy HH:mm:ss',
                  ],
                }),
                requiresVerification: [field.requiresVerification || false],
                isValidationFailed: [field.isValidationFailed || false],
                isSystemField: [field.isSystemField || false],
                isAutoMap: [field.isAutoMap || false],
                isComboValueMapped: [field.isComboValueMapped || false],
                isComboOnDemand: [field.isComboOnDemand || false],
                vmdLookUpField: [field.vmdLookUpField || null],
                isVMDLookUpField: [field.isVMDLookUpField || false],
                isReadOnly: [field.isReadOnly || false],
                id: [field.id || null],
                displayName: [field.displayName || null],
              });

              this.indexingFields.push(group);
            });

            this.loadValuesOfSendToFlowsData(event); 
            setTimeout(() => {
              this.indexingFieldsPanel.open();
            }, 0);
          },
          error: (error) => {
            this.isIndexFieldsLoading = false;
            this.commonService.showMessage('Failed to fetch Index Fields.','error');
          },
        });
    }
  }

  submitCombinedForms(): void {
    if (this.form.invalid) {
      this.isFormSubmitted = false;
      const hasInvalidIndexField = this.indexingFields.controls.some(
        (control) => {
          const group = control as FormGroup;
          const isMandatory = group.get('isMandatory')?.value;
          const value = group.get('valueAsString')?.value;
          return isMandatory && !value;
        }
      );
      if (hasInvalidIndexField) {
        setTimeout(() => this.indexingFieldsPanel.open(), 0);
      }
      return;
    }
    this.isFormSubmitted = true;
    this.isSubmitting = true;
    let webUploadformData = new FormData();
    let uploadingFiles = this.files;
    this.assignWebUpload(uploadingFiles[0].name);
    uploadingFiles.forEach((file) => {
      webUploadformData.append('image', file);
    });
    webUploadformData.append('createDocument',JSON.stringify(this.webUploadDto));
    this.createDocument(webUploadformData);
  }

  createDocument(webUploadformData: FormData) {
    this.webUploadService.createDocumentWebUpload(webUploadformData).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        if (this.sendToWorkflow) {
          this.successMessage = `Document Created Successfully and sent to Workflow, Batch ID:${response.batchId}, Document ID:${response.documentId}, Workitem ID:${response.workItemId}`;
        } else {
          this.successMessage = `Document Created Successfully and with Batch ID:${response.batchId}, Document ID:${response.documentId}`;
        }
        this.resetAll();
        this.resetImage();
        this.panels.forEach((panel) => panel.close());
        this.commonService.showMessage(this.successMessage, 'success', false);
      },
      error: (error) => {
        this.isSubmitting = false;
        this.successMessage = '';
        this.errorMessage=error.error.message;
        this.commonService.showMessage(this.errorMessage, 'error', false);
      },
    });
  }

  assignWebUpload(firstFileName: string): void {
    this.webUploadDto = new WebUpload();
    this.webUploadDto.abbyyDocId = null;
    this.webUploadDto.businessAreaId = this.selectedBusinessArea;
    this.webUploadDto.convertToPDF = null;
    this.webUploadDto.docTypeId = this.selectedDocumentType;
    this.webUploadDto.documentStream = null;
    this.webUploadDto.documentName = firstFileName;
    this.webUploadDto.documentSource = 'Web_Upload';
    this.webUploadDto.documentType = this.selectedDocTypeName;
    this.webUploadDto.indexFields = this.indexingFields.value;
    if (this.uploadOptionsQueueOnSelect) {
      this.webUploadDto.queueID = this.selectedstartQueueId;
    }
    this.webUploadDto.sendEmailNotification = this.sendToNotification;
    this.webUploadDto.sendToNewBatch =
      this.enabledBatch == 'add' ? true : false;
    this.webUploadDto.sendToWorkflow = this.sendToWorkflow;
    this.webUploadDto.systemId = Number(
      this.globalVariable.getSelectedSystemId
    );
    this.webUploadDto.userGpid = this.globalVariable.getUserGPID;

    this.webUploadDto.indexFields.forEach((field) => {
      if (field.valueAsString != null && field.controlName === 'DATE') {
        const rawFormat = field?.fieldDateFormat?.defaultFormat.split(' ')[0];
        const date = this.parseDateValue(field.valueAsString, rawFormat);
        if (date) {
          field.valueAsString = this.formatDate(date, rawFormat);
        }
      }
      if (field.controlName === 'CHECK_BOX') {
        if (typeof field.valueAsString === 'boolean') {
          field.valueAsString = (field.valueAsString as any) ? 'true' : 'false';
        } else if (field.valueAsString === null || field.valueAsString === undefined || field.valueAsString === '') {
          field.valueAsString = 'false';
        }
      }
    });
  }

  getUserSystemPerferences(): void {
    this.commonService.getUserPerferences().subscribe({
      next: (response: UserSystemPreference[]) => {
        this.userSystemPreferences = response;
        this.globalVariable.setUserPreferences = response;
        for (const preference of this.userSystemPreferences) {
          switch (preference.preferenceTitle) {
            case 'Send to Workflow':
              this.sendToWorkflow = preference.preferenceValue === 'true';
              this.isSendToWorkFlowEnabled = preference.canOverride;
              break;
            case 'Email Notification':
              this.sendToNotification = preference.preferenceValue === 'true';
              this.isSendToNotificationEnabled = preference.canOverride;
              break;
          }
        }
      },
      error: (error) => {
        this.commonService.showMessage('Error in loading user preferences.','error');
      },
    });
  }

  loadValuesOfSendToFlowsData(event: MatSelectChange): void {
    if (this.webUploadIndexFields && event) { 
      if (this.sendToWorkflow && this.webUploadIndexFields.defaultStartingQueue !== null) {
        this.selectedstartQueueId = this.webUploadIndexFields.defaultStartingQueue.queueId;
        this.documentQueue = [];
        this.documentQueue.push(this.webUploadIndexFields.defaultStartingQueue);
        this.uploadOptionsQueueOnSelect =
        this.webUploadIndexFields.defaultStartingQueue;
        if (this.webUploadIndexFields.startingQueueOptions) {
          this.documentQueue = this.documentQueue.concat(this.webUploadIndexFields.startingQueueOptions);
        } 
      } else {
        this.documentQueue = [];
        this.documentQueue = this.webUploadIndexFields.startingQueueOptions; 
      } 
    }
  }

  onFilesSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;
    const selectedFiles = Array.from(input.files);
    this.validateAndAddFiles(selectedFiles);
    input.value = '';
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'copy'; 
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer?.files || []);
    this.validateAndAddFiles(droppedFiles);
  }

  validateAndAddFiles(fileList: File[]): void {
    this.uploadLimitFailure = false;
    this.invalidFileTypes = [];
    this.oversizedFiles = []; 
    this.duplicateFiles = []; 
    const maxTotalFiles = this.maxFilesLimit;
    const maxFileSizeBytes = (this.maxFileSizeMB) * 1024 * 1024; 
    if (this.files.length + fileList.length > maxTotalFiles) {
      this.uploadLimitFailure = true;
      return;
    } 
    for (const file of fileList) {
      const ext = '.' + (file.name.split('.').pop()?.toUpperCase() || ''); 
      if (!this.allowedFileTypes.includes(ext)) {
        this.invalidFileTypes.push(file.name);
        continue;
      } 
      if (file.size > maxFileSizeBytes) {
        this.oversizedFiles.push(file.name);
        continue;
      } 
      const isDuplicate = this.files.some((existing) => existing.name === file.name);
      if (isDuplicate) {
        this.duplicateFiles.push(file.name);
        continue;
      }
      if (!isDuplicate && this.files.length < maxTotalFiles) {
        this.files.push(file);
      }
    }
  }

  resetImage(): void {
    this.files = [];
    this.selectedFiles = [];
    this.duplicateFiles = []; 
  }

  removeFile(index: number): void {
    const removedFile = this.files[index];
    this.files.splice(index, 1);
    this.duplicateFiles = this.duplicateFiles.filter(f => f !== removedFile.name);
  }

  resetAll(): void { 
    if (this.mainForm) {
      this.mainForm.resetForm();
    } 
    this.selectedBusinessArea = 0;
    this.selectedDocumentType = 0;
    this.selectedDocTypeName = '';
    this.form.reset();
    (this.form.get('indexingFields') as FormArray).clear(); 
    this.webUploadIndexFields = undefined;
    this.selectedstartQueueId = 0;
    this.enabledBatch = 'add';
    this.documentQueue = [];
    this.uploadOptionsQueueOnSelect = null;
    this.files = [];
    this.selectedFiles = [];
    this.isFormSubmitted = false; 
    // Reset file input field manually
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = ''; 
    // Collapse all and open the first panel
    this.panels.forEach((panel) => panel.close()); 
    setTimeout(() => {
      const firstPanel = this.panels.first;
      if (firstPanel) {
        firstPanel.open(); 
      }
    });
  }

  onDateChange(event: any, index: number): void {
    const selectedDate: Date = event.value;
    if (!selectedDate) return;
    if (!selectedDate || !this.indexingFields) return;
    this.indexingFields.at(index).patchValue({ valueAsString: selectedDate });
    this.onDatepickerOpened(index);
  }

  onDatepickerOpened(index: number): void {
    const field = this.indexingFields.at(index).value;
    let rawFormat = field.fieldDateFormat?.defaultFormat;
    const culture = field.fieldDateFormat?.cultureName; 
    if (!rawFormat) return; 
    rawFormat = this.dateService.cleanFormat(rawFormat); 
    const momentFormat = this.dateService.toMomentFormat(rawFormat); 
    if (this.dateAdapter instanceof DynamicDateAdapter) {
      this.dateAdapter.setDynamicFormat(momentFormat);
      this.dateAdapter.setDynamicLocale(culture);
    }
  }

  parseDateValue(valueAsString: string, format: string): Date | null {
    if (!valueAsString || !format) return null;
    const momentFormat = this.dateService.toMomentFormat(this.dateService.cleanFormat(format));
    const parsed = moment(valueAsString, momentFormat, true);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  getMomentFormat(rawFormat: string): string {
    rawFormat = this.dateService.cleanFormat(rawFormat);
    return this.dateService.toMomentFormat(rawFormat);
  }

  formatDate(date: Date, rawFormat: string): string {
    const momentFormat = this.getMomentFormat(rawFormat);
    return moment(date).format(momentFormat);
  }
}
